import { render, staticRenderFns } from "./CustomerStartFromDB.vue?vue&type=template&id=3442eefa&scoped=true&lang=pug&"
import script from "./CustomerStartFromDB.vue?vue&type=script&lang=js&"
export * from "./CustomerStartFromDB.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStartFromDB.vue?vue&type=style&index=0&id=3442eefa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442eefa",
  null
  
)

export default component.exports